<template>
  <div class="aside_2">
    <div class="currentStatus">
      <h4>当前状态</h4>
      <div class="currentWrap">
        <div class="imgWrap">
          <img src="/img/vip.png" alt="" />
        </div>
        <div class="currentWrap_right" v-if="memberExpireTime">
          <h3>超级VIP会员</h3>
          <p>到期时间: <span>{{ memberExpireTime }}</span></p>
        </div>
        <div class="currentWrap_right" v-else>
          <h3>普通用户</h3>
        </div>
      </div>
      <div class="wayType">
        <div
          class="wayItem"
          v-for="(item, index) in payTabs"
          :key="index"
          :class="{ active: payIndex === index }"
          @click="tabCard(index, item.id)"
        >
          <h4>{{ item.typeName }}<span v-if="item.introduction" :title="item.introduction">{{ item.introduction }}</span></h4>
          <p><span class="spanActive" v-if="item.money">￥{{ item.money }}</span><span>{{ item.monthNum }}个月</span></p>
          <img src="/img/recomond.png" alt="" />
          <span class="postionSpan">推荐</span>
        </div>
      </div>
    </div>
    <div class="payWay">
      <h4>支付方式</h4>
      <div class="payWayWrap">
        <div class="payItem_left">
          <div class="codeWrap">
            <el-popover placement="left" width="160" trigger="manual" v-model="showCode">
              <p>微信扫码付款</p>
              <canvas ref="wechatQRcode" class="code"></canvas>
              <div style="text-align: right; margin: 0">
                <el-button type="danger" size="mini" plain @click="closeQRcode">关闭</el-button>
              </div>
              <img slot="reference" class="pay-img" src="/img/wechatPay.png" alt="微信支付" @click="getQRcode" />
            </el-popover>
            <h3>微信支付</h3>
            <p>点击获取微信二维码</p>
          </div>
          <div class="codeWrap">
            <img class="pay-img" src="/img/alipay.26794d29.png" alt="支付宝支付" @click="jumpToAlipay" />
            <h3>支付宝支付</h3>
            <p>点击去支付宝支付</p>
          </div>
        </div>
        <div class="payItem_right">
          <h4>支付<i v-if="showMoney">￥{{ payTabs[payIndex] ? payTabs[payIndex].money : '' }}元</i></h4>
          <p>支付后自动刷新页面，即可享受超级会员</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getUser } from '@/utils/auth'
import QRCode from 'qrcode'

export default {
  name: 'VipManagement',
  data() {
    return {
      memberExpireTime: '',
      payTabs: [],
      payIndex: 0,
      selectedId: null,
      showCode: false,
      showMoney: true
    }
  },
  mounted() {
    const user = getUser()
    if (user) {
      const u = typeof user === 'string' ? JSON.parse(user) : user
      this.memberExpireTime = u.memberExpireTime || ''
    }
    this.getMemberTypes()
  },
  methods: {
    getMemberTypes() {
      this.$axios({
        url: '/realNet/memberType/getMemberTypes',
        method: 'get',
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          this.payTabs = res.data.result.content || res.data.result || []
          if (this.payTabs.length > 0) {
            this.selectedId = this.payTabs[0].id
          }
        }
      })
    },
    tabCard(index, id) {
      this.payIndex = index
      this.selectedId = id
    },
    getQRcode() {
      this.$axios({
        url: '/realNet/pay/vxPayUrl',
        method: 'get',
        params: { memberTypeId: this.selectedId },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          this.showCode = true
          this.$nextTick(() => {
            const canvas = this.$refs.wechatQRcode
            if (canvas) {
              QRCode.toCanvas(canvas, res.data.result, { width: 140 })
            }
          })
        }
      })
    },
    closeQRcode() {
      this.showCode = false
    },
    jumpToAlipay() {
      const newWin = window.open(window.location.href)
      this.$axios({
        url: '/realNet/alipay/pay',
        method: 'get',
        params: { memberTypeId: this.selectedId },
        headers: { token: getToken() }
      }).then(res => {
        setTimeout(() => { newWin.document.write(res.data) }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.aside_2 {
  width: 930px;
}

.currentStatus {
  width: 100%;

  h4 {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  .currentWrap {
    width: 100%;
    height: 90px;
    padding: 26px 20px;
    background: url('/img/line_bg.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .imgWrap {
      width: 50px;
      height: 37px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .currentWrap_right {
      width: 40%;
      height: 45px;
      margin-left: 20px;

      h3 {
        margin-bottom: 10px;
        color: #f1d08f;
        font-size: 16px;
      }

      p {
        font-size: 14px;
        color: hsla(0, 0%, 100%, 0.8);
      }
    }
  }

  .wayType {
    width: 100%;
    height: 100px;
    margin: 30px 0 50px;
    display: flex;

    .wayItem {
      width: 218px;
      height: 100px;
      padding: 15px 10px;
      margin-right: 20px;
      border: 1px solid #3bc0d0;
      background-color: #f3f7f8;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      position: relative;

      h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        color: #000;

        span {
          display: inline-block;
          padding: 0 5px;
          width: 110px;
          height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 1px solid #ff771d;
          color: #ff771d;
          font-size: 13px;
          border-radius: 5px;
          line-height: 22px;
        }
      }

      p {
        font-size: 14px;
        color: #000;

        .spanActive {
          font-size: 20px;
          color: #ff3600;
          margin-right: 5px;
        }
      }

      &.active {
        background-color: #fff6f3;
        border: 2px solid #ff6e40;
      }

      > img {
        display: none;
      }

      &:first-of-type > img {
        position: absolute;
        left: -7px;
        top: -14px;
        display: block;
      }

      .postionSpan {
        font-size: 14px;
        color: #fff;
        display: none;
      }

      &:first-of-type .postionSpan {
        display: inline-block;
        position: absolute;
        left: 0;
        top: -12px;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.payWay {
  width: 100%;

  h4 {
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: 700;
  }

  .payWayWrap {
    width: 100%;
    height: 245px;
    border: 1px solid #eaeced;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;

    .payItem_left {
      width: 40%;
      height: 100%;
      margin-right: 80px;
      display: flex;
      justify-content: space-around;

      .codeWrap {
        width: 150px;
        height: 100%;
        padding: 32px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        h3 {
          font-size: 16px;
        }

        p {
          font-size: 14px;
          color: #888;
        }

        .pay-img {
          width: 112px;
          height: 112px;
          border: 1px solid #e3e3e3;
          cursor: pointer;
        }
      }
    }

    .payItem_right {
      font-size: 16px;
      color: #666;

      h4 {
        font-size: 20px;

        i {
          color: #ff4314;
          font-size: 30px;
        }
      }
    }
  }
}

.code {
  width: 100% !important;
  height: 100% !important;
}
</style>
